import React, { Component } from "react";
import { Button, Row, Col, UncontrolledTooltip } from "reactstrap";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import "react-table/react-table.css";
import TableSearch from "./Forms/TableSearch";
import "./Forms/form.css";

class DataTable extends Component {
    render() {
        const { data, count, manual, pages, page, pageSize, columns, defaultPageSize, loading, filterData, hideActions, setPageNumber, setPageSize, searchParam, actions, searchPlaceholder, hideSearchParam, countTitle, dontShowPagination } = this.props;

        const columnsWithActions = [
            ...columns,
            {
                Header: "Actions",
                minWidth: 120,
                sortable: false,
                filterable: false,
                style: {
                    textAlign: "center",
                },
                Cell: (row) => (
                    <div style={{ whiteSpace: "normal" }}>
                        {actions &&
                            actions.map(
                                (action, index) =>
                                    !row.original[action.hiddenParam] && (
                                        <span key={index}>
                                            {action.isLink && action.isMealPLan ? (
                                                <span>
                                                    <Link
                                                        to={{
                                                            pathname: action.to,
                                                            state: { mealData: row.original },
                                                        }}
                                                    >
                                                        <Button className={`btn mb-2 ${action.btnClass}`} size="sm" id={`btnTooltip-${action.name}-${row.original.id}`}>
                                                            {action.btnIcon({ size: 20 })}
                                                            {action.btnText}
                                                        </Button>
                                                    </Link>{" "}
                                                    {action.tooltip && (
                                                        <UncontrolledTooltip placement="bottom" target={`btnTooltip-${action.name}-${row.original.id}`}>
                                                            {action.tooltip}
                                                        </UncontrolledTooltip>
                                                    )}{" "}
                                                </span>
                                            ) : action.isLink ? (
                                                <span>
                                                    <Link
                                                        to={{
                                                            pathname: action.to,
                                                            state: { postId: row.original.id },
                                                        }}
                                                    >
                                                        <Button className={`btn mb-2 ${action.btnClass}`} size="sm" id={`btnTooltip-${action.name}-${row.original.id}`}>
                                                            {action.btnIcon({ size: 20 })}
                                                            {action.btnText}
                                                        </Button>
                                                    </Link>{" "}
                                                    {action.tooltip && (
                                                        <UncontrolledTooltip placement="bottom" target={`btnTooltip-${action.name}-${row.original.id}`}>
                                                            {action.tooltip}
                                                        </UncontrolledTooltip>
                                                    )}{" "}
                                                </span>
                                            ) : (
                                                action.type !== "content" && (
                                                    <span>
                                                        <Button className={`btn mb-2 ${action.btnClass}`} onClick={() => action.btnAction(row, action.name)} size="sm" id={`btnTooltip-${action.name}-${row.original.id}`}>
                                                            {action.btnIcon({ size: 20 })}
                                                            {action.btnText}
                                                        </Button>{" "}
                                                        {action.tooltip && (
                                                            <UncontrolledTooltip placement="bottom" target={`btnTooltip-${action.name}-${row.original.id}`}>
                                                                {action.tooltip}
                                                            </UncontrolledTooltip>
                                                        )}
                                                    </span>
                                                )
                                            )}
                                        </span>
                                    )
                            )}
                    </div>
                ),
            },
        ];
        const columnsWithoutAction = [...columns];

        return (
            <div>
                <Row>
                    <Col sm="8">
                        <h4 className="data-count">
                            {" "}
                            {count} {countTitle || "Result(s)"} found
                        </h4>
                    </Col>
                    <Col sm="4">{!hideSearchParam && <TableSearch searchParam={searchParam} filterData={filterData} placeholder={searchPlaceholder} />}</Col>
                </Row>
                <ReactTable
                    className="ReactTable -striped -highlight"
                    loading={loading}
                    data={data}
                    pages={pages}
                    page={page}
                    pageSize={pageSize}
                    manual={manual}
                    defaultPageSize={defaultPageSize}
                    columns={hideActions ? columnsWithoutAction : columnsWithActions}
                    onPageChange={(pageIndex) => {
                        setPageNumber(pageIndex);
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                        setPageSize(pageSize, pageIndex);
                    }}
                    showPagination={dontShowPagination ? false : true}
                />
            </div>
        );
    }
}

export default DataTable;
